
import AppSingleton from './services/appSingleton';

let app = AppSingleton.getInstance();